module.exports = __webpack_public_path__ + "assets/img/voucher_0.fa713cb5.svg";